
import { Component, Prop, Vue } from "vue-property-decorator";
import TextInput from "@/components/Reusable/CustomInputs/TextInput.vue";
import DropdownInput from "@/components/Reusable/CustomInputs/DropdownInput.vue";
import { DynamicField } from "@/types/dynamic-data";
import { DynamicFieldReturnType } from "@/types/dynamic-property-path";
import { configStore } from "@/store/store-accessor";
import { getProBadge } from "@/lib/subscriptions/free-mode";
import ElementBadge from "@/components/ElementPropertiesPanel/ElementBadge.vue";

@Component({
  components: { TextInput, DropdownInput, ElementBadge }
})
export default class DynamicDataField extends Vue {
  @Prop()
  field!: DynamicField;

  @Prop()
  active!: boolean;

  @Prop()
  selected!: boolean;

  @Prop()
  accepts!: DynamicFieldReturnType | false;

  get normalizedReturnTypes() {
    return this.field.returnTypes
      .map(returnType => this.normalize(returnType))
      .join(", ");
  }

  get proOnlyField() {
    return this.field.proOnly && configStore.subscriptionMode === "free";
  }

  get proBadge() {
    return getProBadge();
  }

  get normalizedAccepts() {
    return this.normalize(this.accepts || "");
  }

  normalize(text: string) {
    return text.replace("_", " ");
  }
}
